import invariant from 'invariant';
import path from "ramda/es/path";
import __ from "ramda/es/__";
import init from "ramda/es/init";
import isEmpty from "ramda/es/isEmpty";
import last from "ramda/es/last";
import prop from "ramda/es/prop";
import propEq from "ramda/es/propEq";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { fieldType } from '../../validations/constants';
import { invariantDeepPathArray } from '../invariant';
export const getArrayNames = (formDescriptor, arrayName, indices = [], result = [])=>{
    const arrayRecord = formDescriptor[arrayName];
    if (isEmpty(indices)) {
        return [
            arrayRecord.fieldName,
            ...result
        ];
    }
    const newResult = [
        last(indices),
        arrayRecord.fieldName,
        ...result
    ];
    if (arrayRecord.nestedInArray) {
        return getArrayNames(formDescriptor, arrayRecord.nestedInArray, init(indices), newResult);
    } else {
        return newResult;
    }
};
export const getArrayLocation = (formDescriptor, arrayName, result = [])=>{
    const arrayRecord = formDescriptor[arrayName];
    const newResult = [
        arrayRecord.fieldName,
        ...result
    ];
    if (arrayRecord.nestedInArray) {
        return getArrayLocation(formDescriptor, arrayRecord.nestedInArray, newResult);
    } else {
        return newResult;
    }
};
export const getArrayDeepPath = (formDescriptor, arrayName, indices, result = [])=>{
    const arrayRecord = formDescriptor[arrayName];
    invariant(arrayRecord, `array record must exist for ${arrayName}`);
    invariantDeepPathArray(arrayRecord.arrayDeepPath);
    if (isNilOrEmpty(indices)) {
        return [
            ...arrayRecord.arrayDeepPath,
            ...result
        ];
    }
    const newResult = [
        last(indices),
        ...arrayRecord.arrayDeepPath,
        ...result
    ];
    if (arrayRecord.nestedInArray) {
        return getArrayDeepPath(formDescriptor, arrayRecord.nestedInArray, init(indices), newResult);
    } else {
        return newResult;
    }
};
export const getTableRowPath = (formDescriptor, name, indices)=>[
        ...getArrayDeepPath(formDescriptor, name, init(indices)),
        last(indices)
    ];
export const getTableRow = ({ formDescriptor, fieldDescriptor, fieldIndices, formData })=>path(getTableRowPath(formDescriptor, fieldDescriptor.array, fieldIndices), formData);
export const getArrayNestedLevel = (formDescriptor, arrayName, result = 0)=>{
    const arrayRecord = formDescriptor[arrayName];
    invariant(arrayRecord, `array record must exist for ${arrayName}`);
    if (arrayRecord.nestedInArray) {
        return getArrayNestedLevel(formDescriptor, arrayRecord.nestedInArray, result + 1);
    } else {
        return result;
    }
};
export const getDeepPath = (formDescriptor, fieldDescriptor, fieldIndices)=>{
    const { fieldName, type, array, innerDeepPath, deepPath } = fieldDescriptor;
    if (type === fieldType.FIELD_ARRAY) {
        const resolvedFieldIndices = fieldIndices.slice(0, getArrayNestedLevel(formDescriptor, array) + 1);
        invariant(array, `fieldArray ${fieldName} must have specified array`);
        invariantDeepPathArray(innerDeepPath);
        return [
            ...getArrayDeepPath(formDescriptor, array, init(resolvedFieldIndices)),
            last(resolvedFieldIndices),
            ...innerDeepPath
        ];
    }
    const resolvedDeepPath = type === fieldType.ARRAY ? getArrayDeepPath(formDescriptor, fieldName, fieldIndices) : deepPath;
    invariant(resolvedDeepPath, `deepPath must be presented. FieldName: ${fieldDescriptor.fieldName}.`);
    invariantDeepPathArray(resolvedDeepPath);
    return resolvedDeepPath;
};
export const createFieldRecord = (fieldName, fieldIndices)=>`${fieldName}${fieldIndices ?? ''}`;
export const metaDeepPath = path([
    'meta',
    'fieldDescriptor',
    'deepPath'
]);
export const metaFieldName = path([
    'meta',
    'fieldName'
]);
export const metaSection = path([
    'meta',
    'section'
]);
export const metaRapid = path([
    'meta',
    'rapid'
]);
export const metaAsync = path([
    'meta',
    'async'
]);
export const metaKeepData = path([
    'meta',
    'keepData'
]);
export const metaFieldIndices = path([
    'meta',
    'fieldIndices'
]);
export const metaFieldRecord = path([
    'meta',
    'fieldRecord'
]);
export const metaExpandDependent = path([
    'meta',
    'expandDependent'
]);
export const metaValidationGroups = path([
    'meta',
    'validationGroups'
]);
export const payloadValue = path([
    'payload',
    'value'
]);
export const payloadInitiallyDirty = path([
    'payload',
    'initiallyDirty'
]);
export const payloadDisabled = path([
    'payload',
    'disabled'
]);
export const payloadKeepPristine = path([
    'payload',
    'keepPristine'
]);
export const payload = prop('payload');
export const arrayPlacementPathEq = propEq(__, 'arrayPlacementPath');
